export const getDeepObjectValue = (obj, path) => {
  return obj && path
    ? path.split('.').reduce((o, key) => {
        return (o && o[key]) || null;
      }, obj)
    : null;
};
